import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportProductData";
import { WeeklyTradingReportData } from "../types";
import { setData } from "../weeklyTradeDataSlice";

export const useReportProductData = () => {
  const data = useSelector<StoreType, WeeklyTradingReportData[] | undefined>(
    (s) => s.data.reports.weeklyTrade.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  const resetData = React.useCallback(() => {
    dispatch(setData(undefined));
  }, [dispatch]);

  return [data, dispatchLoadData, resetData] as [
    typeof data,
    typeof dispatchLoadData,
    typeof resetData
  ];
};
